import { RequestsWorkspace } from '@/components/requests/requests-workspace'

export function AdminRequests() {
  return <RequestsWorkspace />
}
